import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Input,
    Label,
    FormGroup, CustomInput
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../../services/apiResponse'

import UpdateBloc from './Blocs/UpdateBloc'
import PegawaiSideBar from '../../../GlobalComponents/PegawaiSidebar'
import CustomSelect from '../../../GlobalComponents/CustomSelect'

var reformatOptions = function(raw, label, value) {
  return raw.map(function(data) {
    var newObj = {};
    newObj["label"] = data[label];
    newObj["value"] = data[value];

    return newObj;
  });
};

const jobType = [
    { value: 1, label: 'PNS BKPM' },
    { value: 2, label: 'PNS Non BKPM' },
    { value: 3, label: 'Non PNS' },
    { value: 4, label: 'Belum Bekerja' }
]

class IndexView extends Component {

    updateBloc = new UpdateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            optionGender : [
                { label: "Laki-laki", value: "L" },
                { label: "Perempuan", value: "P" }
            ],
            birthOptionNationality : [
                { label: "Dalam Negeri", value: "Dalam Negeri" },
                { label: "Luar Negeri", value: "Luar Negeri" }
            ],
            birthOptionProvince : [],
            birthOptionCity : [],
            birthOptionCountry : [],
            birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3", // Indonesia
            identityOptionProvince: [],
            identityOptionCity: [],
            identityOptionDistrict: [],
            identityOptionVillage: [],
            isLocal: 1,
            pnsStatus: 1
        }
    }

    // Select Area

    handleBirthSelectNationality = (birthSelectNationality) => {
        let selected = birthSelectNationality.value;
        if (selected == "Dalam Negeri") {
            this.setState({
                birthSelectedCountry: "61b47307-167d-489f-bb6c-c1c9662acab3",
                isLocal: 1
            })
        } else {
            this.setState({
                birthSelectedCountry: "",
                isLocal: 0
            })
        }
    }

    handleBirthSelectCountry = (birthSelectedCountry) => {
        let selected = birthSelectedCountry.value;
        this.getBirthProvinceByCountry(selected);
    }

    getBirthProvinceByCountry(selected_uuid){
        this.updateBloc.fetchRegionProvince({
          //is_local: 1,
          parent_uuid : selected_uuid,
          type : 2  
        })
    }

    handleBirthSelectProvince = (birthSelectedProvince) => {
      let selected = birthSelectedProvince.value;
      this.getBirthCityByProvince(selected);
    }

    getBirthCityByProvince = (province_uuid) => {
      this.updateBloc.fetchRegionCity({
        is_local: 1,
        type : 3,
        parent_uuid : province_uuid
      })
    }

    handleIdentitySelectProvince = (domicileSelectedProvince) => {
      let selected = domicileSelectedProvince.value;
      this.getIdentityCityByProvince(selected);
    }

    // get data city where province selected
    getIdentityCityByProvince = (province_uuid) => {
        this.updateBloc.fetchIdentityCity({
            is_local: 1,
            type : 3,
            parent_uuid : province_uuid
        })
    }

    handleIdentitySelectCity = (identitySelectedCity) => {
        let selected = identitySelectedCity.value;
        this.getIdentityDistrictByCity(selected);
    }

    // get data district where city selected
    getIdentityDistrictByCity = (city_uuid) => {
        this.updateBloc.fetchIdentityDistrict({
            is_local: 1,
            type : 4,
            parent_uuid : city_uuid
        })
    }

    handleIdentitySelectDistrict = (identitySelectedDistrict) => {
        let selected = identitySelectedDistrict.value;
        this.getIdentityVillageByDistrict(selected);
    }

    // get data village where district selected
    getIdentityVillageByDistrict = (district_uuid) => {
        this.updateBloc.fetchIdentityVillage({
            is_local: 1,
            type : 5,
            parent_uuid : district_uuid
        })
    }

    // End Select Area

    submitData = async () => {
        await this.updateBloc.fetchUpdate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.updateBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        this.setState({
                            dataForm: {
                              uuid: response.family_uuid,
                              employee_uuid: response.family_employee_uuid,
                              place_of_birth_city_uuid: response.family_place_of_birth_city_uuid,
                              name: response.family_name,
                              place_of_birth_province_uuid : response.family_place_of_birth_province_uuid,
                              place_of_birth_city_text: response.family_place_of_birth_city_text,
                              date_of_birth : response.family_date_of_birth,
                              gender : response.family_gender,
                              profession : response.family_profession,
                              identity_address : response.family_identity_address,
                              identity_province_uuid : response.family_identity_province_uuid,
                              identity_city_uuid : response.family_identity_city_uuid,
                              identity_districts_uuid : response.family_identity_districts_uuid,
                              identity_village_uuid : response.family_identity_village_uuid,
                              identity_postal_code : response.family_identity_postal_code,
                              phone_number : response.family_phone_number,
                              place_of_birth_national: response.family_place_of_birth_national,
                              place_of_birth_country_uuid : response.family_place_of_birth_country_uuid,
                              place_of_birth_city_text : response.family_place_of_birth_city_text,
                              jobType: response.family_spouse_job_type,
                              family_profession_pns_nip: response.family_profession_pns_nip,
                              family_status: response.family_status,
                              family_status_description: response.family_status_description,
                              family_identity_number: response.family_identity_number,
                              familty_family_card_number: response.familty_family_card_number
                            },
                            birthSelectedCountry : response.family_place_of_birth_country_uuid,
                            isLocal : response.family_place_of_birth_national == "Luar Negeri" ? 0 : 1,
                            pnsStatus: response.family_spouse_job_type
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.updateBloc.fetchDetail({uuid: queryParams.get('uuid') })

        // get data birth country
        this.updateBloc.regionCountryChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            birthOptionCountry: reformatOptions(
                                response.result, 
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.updateBloc.fetchRegionCountry({
          type : 1  
        })

        // get data birth province
        this.updateBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)

                        this.setState({
                            birthOptionProvince: reformatOptions(
                                response.result, 
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.getBirthProvinceByCountry(this.state.birthSelectedCountry);

        // get data city where province selected
        this.updateBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        //console.log(response)
                        
                        this.setState({
                            birthOptionCity: reformatOptions(
                                response.result, 
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.getBirthCityByProvince(this.dataForm ? this.dataForm.place_of_birth_province_uuid : '');

        // get data province identity
        this.updateBloc.identityProvinceChannel.subscribe((result) => {
          switch (result.status) {
              case apiResponse.COMPLETED:
                  if(result.data.status) {
                      let response = result.data.response
                      //console.log(response)
                      
                      this.setState({
                          identityOptionProvince: reformatOptions(
                              response.result, 
                              'region_name',
                              'region_uuid'
                          )
                      })
                  }
                  break
              case apiResponse.ERROR:
                  
                  break
              default:
                  break
            }
        })
        this.updateBloc.fetchIdentityProvince({
          is_local: 1,
          type : 2  
        })

        // get city identity
        this.updateBloc.identityCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        
                        this.setState({
                            identityOptionCity: reformatOptions(
                                response.result, 
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.getIdentityCityByProvince(this.dataForm ? this.dataForm.identity_province_uuid : '')

        // get district identity
        this.updateBloc.identityDistrictChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        
                        this.setState({
                            identityOptionDistrict: reformatOptions(
                                response.result, 
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.getIdentityDistrictByCity(this.dataForm ? this.dataForm.identity_city_uuid : '')

        // get village identity
        this.updateBloc.identityVillageChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        
                        this.setState({
                            identityOptionVillage: reformatOptions(
                                response.result, 
                                'region_name',
                                'region_uuid'
                            )
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        this.getIdentityVillageByDistrict(this.dataForm ? this.dataForm.identity_districts_uuid : '')
    }

    componentWillUnmount(){
        this.updateBloc.updateChannel.unsubscribe()
        this.updateBloc.detailChannel.unsubscribe()
        this.updateBloc.regionCountryChannel.unsubscribe()
        this.updateBloc.regionProvinceChannel.unsubscribe()
        this.updateBloc.regionCityChannel.unsubscribe()
        this.updateBloc.identityProvinceChannel.unsubscribe()
        this.updateBloc.identityCityChannel.unsubscribe()
        this.updateBloc.identityDistrictChannel.unsubscribe()
        this.updateBloc.identityVillageChannel.unsubscribe()
    }


    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="saudara"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Edit Saudara</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                      <AvField
                                            name="uuid"
                                            type="hidden"
                                            id="family_uuid"
                                            value={this.state.dataForm.uuid}
                                      />
                                      <AvField
                                            name="employee_uuid"
                                            type="hidden"
                                            id="employee_uuid"
                                            value={this.state.dataForm.employee_uuid}
                                      />

                                            {this.state.dataForm.family_status == 2 ?
                                            <Row className="mb-3">
                                                <Col md="12">
                                                    <div class="alert-dismissible fade show alert alert-danger alert-dismissible fade show" role="alert">
                                                        <button type="button" class="close" aria-label="Close"><span aria-hidden="true">×</span></button>
                                                        <i class="uil uil-exclamation-octagon me-2"></i> Catatan Approval : {this.state.dataForm.family_status_description}
                                                    </div>
                                                </Col>
                                            </Row>
                                            : '' }

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="name"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="name"
                                                    placeholder="Nama..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="name"
                                                    value={this.state.dataForm.name}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                                <label className="col-md-3 col-form-label">
                                                    Nomor Induk Kependudukan
                                                    {/* <span className="text-danger">*</span> */}
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                    name="family_identity_number"
                                                    placeholder="Nomor Induk Kependudukan..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Induk Kependudukan"
                                                    className="form-control"
                                                    // validate={{ required: { value: true } }}
                                                    id="family_identity_number"
                                                    value={this.state.dataForm.family_identity_number}
                                                    />
                                                </Col>
                                                </Row>

                                            <Row className="mb-3">
                                                <label className="col-md-3 col-form-label">
                                                    Nomor Kartu Keluarga 
                                                    {/* <span className="text-danger">*</span> */}
                                                </label>
                                                <Col md="4">
                                                    <AvField
                                                    name="familty_family_card_number"
                                                    placeholder="Nomor Kartu Keluarga..."
                                                    type="text"
                                                    errorMessage="Masukkan Nomor Kartu Keluarga"
                                                    className="form-control"
                                                    id="familty_family_card_number"
                                                    value={this.state.dataForm.familty_family_card_number}
                                                    />
                                                </Col>
                                            </Row>

                                        <hr />
                                        <Row>
                                            <Col md="5">
                                                <label className="fw-bold">#Tempat Lahir</label>
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="tempat_lahir"
                                                className="col-md-3 col-form-label"
                                            >
                                            Dalam / Luar Negeri <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name="place_of_birth_national"
                                                    errorMessage="Pilih Dalam / Luar Negeri Lahir"
                                                    onChange={this.handleBirthSelectNationality}
                                                    options={this.state.birthOptionNationality} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Dalam / Luar Negeri Lahir"
                                                    defaultValue={this.state.dataForm.place_of_birth_national}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="tempat_lahir"
                                                className="col-md-3 col-form-label"
                                            >
                                            Negara <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name="place_of_birth_country_uuid"
                                                    errorMessage="Pilih Negara Lahir"
                                                    onChange={this.handleBirthSelectCountry}
                                                    options={this.state.birthOptionCountry} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Negara Lahir"
                                                    defaultValue={this.state.birthSelectedCountry}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3" style={ this.state.isLocal == 0 ? {display:'none'} : {}}>
                                            <label
                                                htmlFor="tempat_ahir"
                                                className="col-md-3 col-form-label"
                                            >
                                            Provinsi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name="birth_province_uuid"
                                                    errorMessage="Pilih Provinsi Lahir"
                                                    onChange={this.handleBirthSelectProvince}
                                                    options={this.state.birthOptionProvince} 
                                                    validate={{ required: { value: this.state.isLocal == 0 ? false : true } }}
                                                    placeholder="Pilih Provinsi Lahir"
                                                    defaultValue={this.state.dataForm.place_of_birth_province_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3" style={ this.state.isLocal == 0 ? {display:'none'} : {}}>
                                            <label
                                                htmlFor="tempat_ahir"
                                                className="col-md-3 col-form-label"
                                            >
                                            Kota <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name="place_of_birth_city_uuid"
                                                    errorMessage="Pilih Kota Lahir"
                                                    options={this.state.birthOptionCity} 
                                                    validate={{ required: { value: this.state.isLocal == 0 ? false : true } }}
                                                    placeholder="Pilih Kota Lahir"
                                                    defaultValue={this.state.dataForm.place_of_birth_city_uuid}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3" style={ this.state.isLocal == 1 ? {display:'none'} : {}}>
                                            <label
                                                htmlFor="place_of_birth_city_text"
                                                className="col-md-3 col-form-label"
                                            >
                                            Kota <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="place_of_birth_city_text"
                                                    placeholder="Kota..."
                                                    type="text"
                                                    errorMessage="Masukkan Kota"
                                                    className="form-control"
                                                    validate={{ required: { value: this.state.isLocal == 1 ? false : true } }}
                                                    id="place_of_birth_city_text"
                                                    value={this.state.dataForm.place_of_birth_city_text}
                                                />
                                            </Col>
                                        </Row>

                                        <hr />
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="date_of_birth"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Lahir <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="date_of_birth"
                                                    placeholder="Tanggal Lahir..."
                                                    type="date"
                                                    errorMessage="Masukkan Tanggal Lahir"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="date_of_birth"
                                                    value={this.state.dataForm.date_of_birth}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="gender"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Kelamin <span className="text-danger">*</span>
                                            </label>
                                            <Col md="4">
                                                <CustomSelect 
                                                    name="gender"
                                                    errorMessage="Pilih Jenis Kelamin"
                                                    options={this.state.optionGender} 
                                                    placeholder="Pilih Jenis Kelamin"
                                                    defaultValue={this.state.dataForm.gender}
                                                />
                                            </Col>
                                        </Row>
                                        
                                        <Row className="mb-3">
                                            <Label htmlFor="fieldJobType" className="col-md-3 col-form-label">Jenis Pekerjaan : <span className="text-danger">*</span></Label>
                                            <Col md="4">
                                                <CustomSelect 
                                                    name="jobType"
                                                    options={jobType}
                                                    isSearchable={false}
                                                    defaultValue={1}
                                                    onChange={opt => this.setState({ pnsStatus: opt.value })}
                                                    validate={{ required: { value: true } }}
                                                    defaultValue={this.state.dataForm.jobType}
                                                />
                                            </Col>
                                        </Row>
                                        {(
                                                    this.state.pnsStatus === "1" ||
                                                    this.state.pnsStatus === "2"
                                                ) &&
                                            <Row className="mb-3">
                                                <Label htmlFor="fieldNIP" className="col-md-3 col-form-label">NIP : <span className="text-danger">*</span></Label>
                                                <Col md="4">
                                                    <AvField
                                                        name="nip"
                                                        placeholder="NIP..."
                                                        errorMessage="Masukkan NIP"
                                                        type="number"
                                                        className="form-control"
                                                        id="fieldNIP"
                                                        validate={{ required: { value: true } }}
                                                        value={this.state.dataForm.family_profession_pns_nip}
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                    
                                        { this.state.pnsStatus == 3 &&
                                            <Row className="mb-3">
                                                <label
                                                    htmlFor="profession"
                                                    className="col-md-3 col-form-label"
                                                >
                                                Pekerjaan <span className="text-danger">*</span>
                                                </label>
                                                <Col md="5">
                                                    <AvField
                                                        name="profession"
                                                        placeholder="Pekerjaan..."
                                                        type="text"
                                                        errorMessage="Masukkan Pekerjaan"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="profession"
                                                        value={this.state.dataForm.profession}
                                                    />
                                                </Col>
                                            </Row>
                                        }

                                        <hr />
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="alamat"
                                                className="col-md-3 col-form-label"
                                            >
                                            Alamat <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    name="identity_address"
                                                    placeholder="Alamat..."
                                                    type="textarea"
                                                    errorMessage="Masukkan Alamat"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="alamat"
                                                    value={this.state.dataForm.identity_address}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            Provinsi <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name="identity_province_uuid"
                                                    errorMessage="Pilih Provinsi"
                                                    onChange={this.handleIdentitySelectProvince}
                                                    options={this.state.identityOptionProvince} 
                                                    validate={{ required: { value: true } }}
                                                    defaultValue={this.state.dataForm.identity_province_uuid}
                                                    placeholder="Pilih Provinsi"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            Kota/Kabupaten <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name="identity_city_uuid"
                                                    errorMessage="Pilih Kota"
                                                    onChange={this.handleIdentitySelectCity}
                                                    options={this.state.identityOptionCity} 
                                                    validate={{ required: { value: true } }}
                                                    defaultValue={this.state.dataForm.identity_city_uuid}
                                                    placeholder="Pilih Kota"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            Kecamatan
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name="identity_districts_uuid"
                                                    errorMessage="Pilih Kecamatan"
                                                    onChange={this.handleIdentitySelectDistrict}
                                                    options={this.state.identityOptionDistrict} 
                                                    defaultValue={this.state.dataForm.identity_districts_uuid}
                                                    placeholder="Pilih Kecamatan"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                className="col-md-3 col-form-label"
                                            >
                                            Desa/Kelurahan
                                            </label>
                                            <Col md="5">
                                                <CustomSelect 
                                                    name="identity_village_uuid"
                                                    errorMessage="Desa/Kelurahan"
                                                    options={this.state.identityOptionVillage} 
                                                    defaultValue={this.state.dataForm.identity_village_uuid}
                                                    placeholder="Desa/Kelurahan"
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="identity_postal_code"
                                                className="col-md-3 col-form-label"
                                            >
                                            Kode Pos <span className="text-danger">*</span>
                                            </label>
                                            <Col md="3">
                                                <AvField
                                                    name="identity_postal_code"
                                                    placeholder="Kode Pos..."
                                                    type="number"
                                                    errorMessage="Masukkan Kode Pos"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="identity_postal_code"
                                                    value={this.state.dataForm.identity_postal_code}
                                                />
                                            </Col>
                                        </Row>
                                        <hr />
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="phone_number"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nomor Telepon <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <AvField
                                                    name="phone_number"
                                                    placeholder="Nomor Telepon..."
                                                    type="number"
                                                    errorMessage="Masukkan Nomor Telepon"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="phone_number"
                                                    value={this.state.dataForm.phone_number}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <div className="form-check form-switch mb-3">
                                                <AvCheckboxGroup name="checkboxExample" required errorMessage="Agreement harus di centang">
                                                    <AvCheckbox label="Saya yakin dan bertanggung jawab atas data ini" value="1" />
                                                </AvCheckboxGroup>
                                                
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?saudara">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?saudara'/>
                : null }
            </Fragment>
        )
    }

}

//export default IndexView
export default withRouter(IndexView);